<template>
  <!-- 订单活动列表 -->
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb" />
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div" style="
          display: flex;
          justify-content: space-between;
          align-items: center;
        ">
        <div>数据总览</div>
        <div class="shuaxuan-date">
          <div class="shuaxin" @click="restQuery"></div>
          <div @click="handleSelectDateTypeValue(0)" :style="{ color: customType == 0 ? '#4182eb' : '#515a6e' }">日</div>
          <div @click="handleSelectDateTypeValue(2)" :style="{ color: customType == 2 ? '#4182eb' : '#515a6e' }">周</div>
          <div @click="handleSelectDateTypeValue(1)" :style="{ color: customType == 1 ? '#4182eb' : '#515a6e' }">月</div>
          <div @click="handleSelectDateTypeValue(3)" :style="{ color: customType == 3 ? '#4182eb' : '#515a6e' }">自定义
          </div>
          <!-- 日 -->
          <el-date-picker v-model="singleDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd" key="singleDate"
            @change="singleDateChange" :clearable="false" v-if="customType == 0">
          </el-date-picker>
          <!-- 周 -->
          <el-date-picker v-model="singleDate" type="week" placeholder="选择日期" format="yyyy 第 WW 周" key="singleDateA"
            value-format="yyyy-MM-dd" @change="handleSelectTime" :clearable="false" v-if="customType == 2">
          </el-date-picker>
          <!-- 月 -->
          <el-date-picker v-model="singleDate" type="month" placeholder="选择日期" value-format="yyyy-MM" key="singleDateB"
            @change="singleDateChange" :clearable="false" v-if="customType == 1">
          </el-date-picker>
          <!-- 自定义时间 -->
          <el-date-picker style="width: 400px" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期" v-if="customType == 3" value-format="yyyy-MM-dd" v-model="doubleDateList"
            key="singleDateC" @change="doubleDateChange">
          </el-date-picker>
        </div>
      </div>

      <div class="page-action-btns flex margin-tb-10" v-if="0">
        <div class="flex-grow-1"></div>
        <button class="common-bg-button" @click="
          () => {
            showMultiQuery = !showMultiQuery;
          }
        ">
          高级筛选
        </button>
      </div>
      <div class="multi-query-div el-fade-in-linear margin-t-20 margin-b-20" v-if="showMultiQuery">
        <div class="margin-bottom-16">
          <el-row :gutter="20" class="margin-top-10">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">日期类型</p>
              <el-select v-model="queryInfo.dateType" size="small" class="full-width" placeholder="请选择"
                @change="handleSelectDateType">
                <el-option label="日" :value="0" />
                <el-option label="周" :value="2" />
                <el-option label="月" :value="1" />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">时间</p>
              <div class="flex-r">
                <el-date-picker v-if="queryInfo.dateType === 0" v-model="queryInfo.dateStr" type="date" size="small"
                  value-format="yyyy-MM-dd" placeholder="选择开始时间" prefix-icon="el-icon-date" style="width: 100%" />
                <el-date-picker v-if="queryInfo.dateType === 2" v-model="dateStr" type="week" size="small"
                  format="yyyy 第 WW 周" value-format="yyyy-MM-dd" placeholder="选择周" style="width: 100%"
                  @change="handleSelectTime" clearable />
                <el-date-picker v-if="queryInfo.dateType === 1" v-model="queryInfo.dateStr" type="month" size="small"
                  placeholder="选择月" style="width: 100%" value-format="yyyy-MM" clearable />
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="query-flex-btns-div">
          <button class="common-bg-button" @click="getListData">
            搜 索
          </button>
          <button class="common-bg-button" @click="resetQuery()">
            重 置
          </button>
        </div>
      </div>

      <div class="content-item1 margin-bottom-16">
        <div class="item1-left">
          <div>
            <div class="border-line">
              <div>累计页面浏览次数</div>
              <div class="item8-title">{{ dataOverviewFormList.viewCount.toLocaleString() || 0 }}</div>
            </div>
            <div class="border-line">
              <div>累计留资点击人数</div>
              <div class="item8-title">{{ dataOverviewFormList.createUserCount.toLocaleString() || 0 }}</div>
            </div>
            <div class="border-line">
              <div>累计签约成功人数</div>
              <div class="item8-title">{{ dataOverviewFormList.signedUserCount.toLocaleString() || 0 }}</div>
            </div>
            <div class="border-line">
              <div>累计活动绑桩用户数</div>
              <div class="item8-title">{{ dataOverviewFormList.bindPileUserCount.toLocaleString() || 0 }}</div>
            </div>
            <div class="border-line">
              <div>累计已解约(退出)用户数</div>
              <div class="item8-title">{{ dataOverviewFormList.exitUserCount.toLocaleString() || 0 }}</div>
            </div>
          </div>

          <div>
            <div class="border-line">
              <div>累计留资点击次数</div>
              <div class="item8-title">{{ dataOverviewFormList.createCount.toLocaleString() || 0 }}</div>
            </div>

            <div class="border-line">
              <div>累计同意签约点击人数</div>
              <div class="item8-title">{{ dataOverviewFormList.clickSignUserCount.toLocaleString() || 0 }}</div>
            </div>

            <div class="border-line">
              <div>累计签约转化率</div>
              <div class="item8-title">{{
                dataOverviewFormList?.totalSignedUserRatio !== undefined
                  ? (dataOverviewFormList.totalSignedUserRatio + '%')
                  : '-'
              }}</div>
            </div>

            <div class="border-line">
              <div>累计绑桩转化率</div>
              <div class="item8-title"> {{ dataOverviewFormList?.totalBindPileRatio !== undefined
                ? (dataOverviewFormList.totalBindPileRatio + '%')
                : '-'
              }}</div>
            </div>
            <div class="border-line">
              <div>累计有效签约用户数 </div>
              <div class="item8-title">{{ dataOverviewFormList.validSignUserCount.toLocaleString() || 0 }}</div>
            </div>
          </div>
        </div>
        <div class="border-line item1-right">
          <div class="item8-title">累计活动路径数据统计及转化漏斗图</div>
          <div id="loudou-echart" style="width: 600px; height: 700px" ref="loudouEchart"></div>
        </div>
      </div>
      <!-- 用户参与活动数据统计 -->
      <div class="item4-title">用户参与活动数据统计</div>
      <!-- 数据概览 -->
      <div class="content-item8 margin-bottom-16" v-if="0">
        <div class="item8-info border-line">
          <div class="item8-title">进入活动页面总浏览次数</div>
          <div class="item8-value">{{ formList.apvCount || "-" }}</div>
          <div :style="{ color: formList.apvGRate >= 0 ? '#7aec7e' : '#ea7281' }">
            较{{
              queryInfo.dateType === 0
                ? "前一天"
                : queryInfo.dateType === 1
                  ? "上个月"
                  : queryInfo.dateType === 2
                    ? "上周期"
                    : "-"
            }}{{ formList.apvGRate >= 0 ? "提升" : "下降" }}
            {{ Math.abs(formList.apvGRate) || "-" }} % ({{
              Math.abs(formList.apvGInc) || "-"
            }}
            人)
          </div>
        </div>
        <div class="item8-info border-line">
          <div class="item8-title">活动成功签约人数</div>
          <div class="item8-value">{{ formList.suCount }}</div>
          <div :style="{ color: formList.suDRate >= 0 ? '#7aec7e' : '#ea7281' }">
            较{{
              queryInfo.dateType === 0
                ? "前一天"
                : queryInfo.dateType === 1
                  ? "上个月"
                  : queryInfo.dateType === 2
                    ? "上周期"
                    : "-"
            }}{{ formList.suDRate >= 0 ? "提升" : "下降" }}
            {{ Math.abs(formList.suDRate) }} % ({{ Math.abs(formList.suDInc) }}
            人)
          </div>
        </div>
        <div class="item8-info border-line">
          <div class="item8-title">活动成功签约转化率</div>
          <div class="item8-value">{{ formList.suCRate }} %</div>
          <div :style="{ color: formList.suCRGRate >= 0 ? '#7aec7e' : '#ea7281' }">
            较{{
              queryInfo.dateType === 0
                ? "前一天"
                : queryInfo.dateType === 1
                  ? "上个月"
                  : queryInfo.dateType === 2
                    ? "上周期"
                    : "-"
            }}{{ formList.suCRGRate >= 0 ? "提升" : "下降" }}
            {{ Math.abs(formList.suCRGRate) }} % ({{
              Math.abs(formList.suCRGPoints)
            }}
            人)
          </div>
        </div>
        <div class="item8-info border-line">
          <div class="item8-title">活动已绑桩用户数</div>
          <div class="item8-value">{{ formList.tuCount }}</div>
          <div :style="{ color: formList.tuGRate >= 0 ? '#7aec7e' : '#ea7281' }">
            较{{
              queryInfo.dateType === 0
                ? "前一天"
                : queryInfo.dateType === 1
                  ? "上个月"
                  : queryInfo.dateType === 2
                    ? "上周期"
                    : "-"
            }}{{ formList.tuGRate >= 0 ? "提升" : "下降" }}
            {{ Math.abs(formList.tuGRate) }} % ({{ Math.abs(formList.tuGInc) }}
            人)
          </div>
        </div>
        <div class="item8-info border-line">
          <div class="item8-title">活动绑桩转化率</div>
          <div class="item8-value">{{ formList.tcRate }} %</div>
          <div :style="{ color: formList.tcRGRate >= 0 ? '#7aec7e' : '#ea7281' }">
            较{{
              queryInfo.dateType === 0
                ? "前一天"
                : queryInfo.dateType === 1
                  ? "上个月"
                  : queryInfo.dateType === 2
                    ? "上周期"
                    : "-"
            }}{{ formList.tcRGRate >= 0 ? "提升" : "下降" }}
            {{ Math.abs(formList.tcRGRate) }} % ({{
              Math.abs(formList.tcRGPoints)
            }}
            人)
          </div>
        </div>
      </div>

      <!-- 渠道数据统计 -->
      <div class="margin-bottom-16 border-line" style="width: 100%">
        <div style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
          ">
          <div style="font-weight: 600">
            用户报名参与活动路径数据统计表（时间筛选周期内）
          </div>
          <div>
            <el-button type="primary" size="mini" @click="toExportList">一键导出全部</el-button>
          </div>
        </div>
        <div style="display: flex; justify-content: flex-end">
          <div class="item-title-select">
            <div class="select-item" :class="{ active: item.value === queryInfo.pageType }"
              v-for="item in activeSelectList" :key="item.value" @click="handleSelectPageType(item)">
              {{ item.label }}
            </div>
          </div>
        </div>
        <el-table class="el-table" :data="channelList" row-key="id" lazy border style="width: 100%"
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }" :cell-style="{ 'text-align': 'center' }"
          :header-cell-style="{
            background: '#FAFAFA',
            color: '#8F9BB3',
            fontSize: '14px',
            textAlign: 'center',
            border: '1px solid #F0F0F0',
          }">
          <el-table-column prop="name" label="渠道" width="250" :key="tableKey" />
          <el-table-column prop="orderNumber" label="进入活动页浏览次数及环比">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.apvCount }}</div>
                <!-- <div>{{ scope.row.apvInc }} ({{ scope.row.apvRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.apvInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.apvInc }}</span>
                  <span :style="{
                    color: scope.row.apvRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.apvRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="0元下单点击次数及环比">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.zocCount }}</div>
                <!-- <div>{{ scope.row.zocInc }} ({{ scope.row.zocRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.zocInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.zocInc }}</span>
                  <span :style="{
                    color: scope.row.zocRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.zocRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="0元下单报名成功人数相关统计">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.createOrderCount }}</div>
                <!-- <div>{{ scope.row.zocInc }} ({{ scope.row.zocRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color:
                      scope.row.createOrderInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.createOrderInc }}</span>
                  <span :style="{
                    color:
                      scope.row.createOrderRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.createOrderRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="点击直接签约人数相关统计">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.signDirectlyCount }}</div>
                <!-- <div>{{ scope.row.zocInc }} ({{ scope.row.zocRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color:
                      scope.row.signDirectlyInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.signDirectlyInc }}</span>
                  <span :style="{
                    color:
                      scope.row.signDirectlyRatio >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">({{ scope.row.signDirectlyRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="点击了解更多人数相关统计">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.knowMoreCount }}</div>
                <!-- <div>{{ scope.row.zocInc }} ({{ scope.row.zocRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.knowMoreInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.knowMoreInc }}</span>
                  <span :style="{
                    color:
                      scope.row.knowMoreRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.knowMoreRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="签约短信点击次数相关统计">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.signMessageCount }}</div>
                <!-- <div>{{ scope.row.zocInc }} ({{ scope.row.zocRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color:
                      scope.row.signMessageInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.signMessageInc }}</span>
                  <span :style="{
                    color:
                      scope.row.signMessageRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.signMessageRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="活动签约按钮点击次数及环比">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.sbcCount }}</div>
                <!-- <div>{{ scope.row.sbcInc }} ({{ scope.row.sbcRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.sbcInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.sbcInc }}</span>
                  <span :style="{
                    color: scope.row.sbcRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.sbcRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="活动签约按钮点击人数相关统计">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.sbcUserCount }}</div>
                <!-- <div>{{ scope.row.sbcInc }} ({{ scope.row.sbcRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.sbcUserInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.sbcUserInc }}</span>
                  <span :style="{
                    color:
                      scope.row.sbcUserRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.sbcUserRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="点击阅读并签署按钮次数">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.rauCount }}</div>
                <div>
                  <span :style="{
                    color: scope.row.rauInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.rauInc }}</span>
                  <span :style="{
                    color: scope.row.rauRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.rauRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="点击阅读并签署人数">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.rauUserCount }}</div>
                <div>
                  <span :style="{
                    color: scope.row.rauUserInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.rauUserInc }}</span>
                  <span :style="{
                    color:
                      scope.row.rauUserRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.rauUserRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="服务协议页面浏览次数">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.browseAgreementCount }}</div>
                <div>
                  <span :style="{
                    color:
                      scope.row.browseAgreementInc >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">{{ scope.row.browseAgreementInc }}</span>
                  <span :style="{
                    color:
                      scope.row.browseAgreementRatio >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">({{ scope.row.browseAgreementRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="服务协议页面浏览人数">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.browseAgreementUserCount }}</div>
                <div>
                  <span :style="{
                    color:
                      scope.row.browseAgreementUserInc >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">{{ scope.row.browseAgreementUserInc }}</span>
                  <span :style="{
                    color:
                      scope.row.browseAgreementUserRatio >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">({{ scope.row.browseAgreementUserRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="免押协议签约人数及环比">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.fdaCount }}</div>
                <!-- <div>{{ scope.row.fdaInc }} ({{ scope.row.fdaRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.fdaInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.fdaInc }}</span>
                  <span :style="{
                    color: scope.row.fdaRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.fdaRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="商家扣款协议签约人数及环比">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.mdaCount }}</div>
                <!-- <div>{{ scope.row.mdaInc }} ({{ scope.row.mdaRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.mdaInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.mdaInc }}</span>
                  <span :style="{
                    color: scope.row.mdaRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.mdaRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNumber" label="活动成功签约人数及环比">
            <template slot-scope="scope">
              <div style="
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                ">
                <div>{{ scope.row.sscCount }}</div>
                <!-- <div>{{ scope.row.sscInc }} ({{ scope.row.sscRatio }} %)</div> -->
                <div>
                  <span :style="{
                    color: scope.row.sscInc >= 0 ? '#7aec7e' : '#ea7281',
                  }">{{ scope.row.sscInc }}</span>
                  <span :style="{
                    color: scope.row.sscRatio >= 0 ? '#7aec7e' : '#ea7281',
                  }">({{ scope.row.sscRatio }} %)</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-------------------------------------用户报名渠道数据统计------------------------------------------->
      <div class="item4-title">用户报名渠道数据统计</div>
      <div class="content-item1 margin-bottom-16 border-line">
        <div style="width: 100%;">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              margin-bottom: 20px;
            ">
            <div class="font-deep font-size16">
              用户参与活动关键流程趋势图
            </div>
            <div>
              <el-cascader :options="treeData" :props="props" clearable collapse-tags @change="cascaderChange"
                v-model="codeList"></el-cascader>
            </div>
          </div>
          <div id="chartAK" ref="chartAK" style="width: 100%;height: 400PX;"></div>
        </div>
      </div>
      <div class="content-item1 margin-bottom-16">
        <div class="item2-left border-line">
          <div class="font-deep font-size16">各渠道成功报名的用户数占比</div>
          <div class="font-deep font-size14">(时间筛选周期内)</div>
          <div id="chartAA" style="width: 100%; height: 300px" ref="chartAA"></div>
        </div>
        <div class="item2-right border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              各渠道活动路径数据统计<span class="font-size14" style="margin-left: 15px">(时间筛选周期内)</span>
            </div>
            <div>
              <el-select placeholder="请选择" size="mini" v-model="currentStep" @change="currentStepChange">
                <el-option label="进入活动页浏览次数" value="进入活动页浏览次数"></el-option>
                <el-option label="0元下单点击次数" value="0元下单点击次数"></el-option>
                <el-option label="0元下单报名成功人数" value="0元下单报名成功人数"></el-option>
                <el-option label="点击直接签约人数" value="点击直接签约人数"></el-option>
                <el-option label="点击了解更多人数" value="点击了解更多人数"></el-option>
                <el-option label="签约短信点击次数" value="签约短信点击次数"></el-option>
                <el-option label="活动签约按钮点击次数" value="活动签约按钮点击次数"></el-option>
                <el-option label="活动签约按钮点击人数" value="活动签约按钮点击人数"></el-option>
                <el-option label="点击阅读并签署按钮次数" value="点击阅读并签署按钮次数"></el-option>
                <el-option label="点击阅读并签署人数" value="点击阅读并签署人数"></el-option>
                <el-option label="服务协议页面浏览次数" value="服务协议页面浏览次数"></el-option>
                <el-option label="服务协议页面浏览人数" value="服务协议页面浏览人数"></el-option>
                <el-option label="免押协议签约人数" value="免押协议签约人数"></el-option>
                <el-option label="商家扣款协议签约人数" value="商家扣款协议签约人数"></el-option>
                <el-option label="活动成功签约人数" value="活动成功签约人数"></el-option>
              </el-select>
            </div>
          </div>
          <div id="chartAB" style="width: 100%; height: 300px" ref="chartAB"></div>
        </div>
      </div>
      <!-------------------------------------用户安装数据统计------------------------------------------->
      <div class="item4-title">用户安装数据统计</div>
      <div class="content-item1 margin-bottom-16">
        <div class="item3-left border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              数据统计总览<span class="font-size14" style="margin-left: 15px">(时间筛选周期内)</span>
            </div>
            <div></div>
          </div>
          <div
            style="display: flex;flex-wrap: wrap;justify-content: space-between;height: 100%;margin-top: 30px;padding-bottom: 10px;">
            <div class="item8-info border-line" style="width: 45%;height: 40%;">
              <div class="item8-title">累计已联系用户数</div>
              <div class="item8-value" style="font-size: 16px;line-height: 48px;font-weight: bold;">{{ userInstallData.contactedUserCount.toLocaleString() || 0 }}</div>
              <div :style="{ color: userInstallData.contactedUserRatio >= 0 ? '#7aec7e' : '#ea7281' }">
                <span v-if="userInstallData.contactedUserRatio >= 0">↑</span>
                <span v-else>↓</span>
                {{ Math.abs(userInstallData.contactedUserRatio) }} %
                较上周期
              </div>
            </div>
            <div class="item8-info border-line" style="width: 45%;height: 40%;">
              <div class="item8-title">累计预约安装用户数</div>
              <div class="item8-value" style="font-size: 16px;line-height: 48px;font-weight: bold;">{{ '0' }}</div>
              <div :style="{ color: '0' >= 0 ? '#7aec7e' : '#ea7281' }">
                <span v-if="'0' >= 0">↑</span>
                <span v-else>↓</span>
                {{ '0' }} %
                较上周期
              </div>
            </div>
            <div class="item8-info border-line" style="width: 45%;height: 40%;">
              <div class="item8-title">累计不安装/不签约用户数</div>
              <div class="item8-value" style="font-size: 16px;line-height: 48px;font-weight: bold;">{{ userInstallData.noInstallUserCount.toLocaleString() || 0 }}</div>
              <div :style="{ color: userInstallData.noInstallUserRatio >= 0 ? '#7aec7e' : '#ea7281' }">
                <span v-if="userInstallData.noInstallUserRatio >= 0">↑</span>
                <span v-else>↓</span>
                {{ Math.abs(userInstallData.noInstallUserRatio) }} %
                较上周期
              </div>
            </div>
            <div class="item8-info border-line" style="width: 45%;height: 40%;">
              <div class="item8-title">累计已完成安装用户数</div>
              <div class="item8-value" style="font-size: 16px;line-height: 48px;font-weight: bold;">{{ userInstallData.installUserCount.toLocaleString() || 0 }}</div>
              <div :style="{ color: userInstallData.installUserRatio >= 0 ? '#7aec7e' : '#ea7281' }">
                <span v-if="userInstallData.installUserRatio >= 0">↑</span>
                <span v-else>↓</span>
                {{ Math.abs(userInstallData.installUserRatio) }} %
                较上周期
              </div>
            </div>
          </div>
        </div>
        <div class="item3-right border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              不安装/不签约原因的报名订单数量占比<span class="font-size14" style="margin-left: 15px">(时间筛选周期内)</span>
            </div>
            <div>
              <el-button type="primary" size="mini" v-if="0">数据列表</el-button>
            </div>
          </div>
          <div id="chartAC" style="width: 100%; height: 300px" ref="chartAC"></div>
        </div>
      </div>
      <div class="content-item1 margin-bottom-16">
        <div class="item3-left border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              累计已完成安装的各项安装包长度(米数)订单量占比
            </div>
            <div>
              <el-button type="primary" size="mini" v-if="0">数据列表</el-button>
            </div>
          </div>
          <div id="chartAD" style="width: 100%; height: 300px" ref="chartAD"></div>
        </div>
        <div class="item3-right border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              已完成安装的各项安装包长度(米数)订单数量统计<span class="font-size14" style="margin-left: 15px">(时间筛选周期内)</span>
            </div>
            <div>
              <el-button type="primary" size="mini" v-if="0">数据列表</el-button>
            </div>
          </div>
          <div id="chartAE" style="width: 100%; height: 350px" ref="chartAE"></div>
        </div>
      </div>
      <!-------------------------------------用户充电数据统计------------------------------------------->
      <div class="item4-title">用户充电数据统计</div>
      <div class="content-item1 margin-bottom-16" style="display: flex;flex-wrap: wrap;justify-content: space-between;">
        <div class="border-line" style="width: 30%;margin-bottom: 20px;height: 120px;">
          <div>累计充电订单数</div>
          <div class="item8-title" style=" font-size: 16px;line-height: 48px;font-weight: bold;">{{
            userChargingData.chargeOrderCount.toLocaleString() || 0 }}</div>
        </div>
        <div class="border-line" style="width: 30%;margin-bottom: 20px;height: 120px;">
          <div>累计充电电量</div>
          <div class="item8-title" style=" font-size: 16px;line-height: 48px;font-weight: bold;">{{
            userChargingData.chargeElecTotal.toLocaleString() || 0 }}</div>
        </div>
        <div class="border-line" style="width: 30%;margin-bottom: 20px;height: 120px;">
          <div>累计收取服务费金额</div>
          <div class="item8-title" style=" font-size: 16px;line-height: 48px;font-weight: bold;">{{
            userChargingData.serviceFeeTotal.toLocaleString() || 0 }}</div>
        </div>
        <div class="border-line" style="width: 30%;height: 120px;">
          <div>累计已安装完成的订单数</div>
          <div class="item8-title" style=" font-size: 16px;line-height: 48px;font-weight: bold;">{{
            userInstallData.installUserCount.toLocaleString() || 0 }}</div>
        </div>
        <div class="border-line" style="width: 30%;height: 120px;">
          <div>累计单用户周均充电次数</div>
          <div class="item8-title" style=" font-size: 16px;line-height: 48px;font-weight: bold;">{{
            userChargingData.weeklyAvgChargeCount.toLocaleString() || 0 }}</div>
        </div>
        <div class="border-line" style="width: 30%;height: 120px;">
          <div>累计订单平均充电量</div>
          <div class="item8-title" style=" font-size: 16px;line-height: 48px;font-weight: bold;">{{
            userChargingData.avgChargeElec.toLocaleString() || 0 }}</div>
        </div>
      </div>
      <div class="content-item1 margin-bottom-16" style="display: flex;justify-content: space-between;">
        <div class="border-line" style="width: 30%;margin-bottom: 20px;height: 420px;">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">单用户周均充电次数</div>
            <div class="font-size14">(时间筛选周期内)</div>
          </div>
          <div style="
              display: flex;
              justify-content: flex-end;
              margin-top: 10px;
            ">
            <div>
              <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                size="mini" value-format="yyyy-MM-dd" v-model="dateListA" @change="getDateListA">
              </el-date-picker>
            </div>
          </div>
          <div ref="chartAF" style="width: 100%; height: 300px"></div>
          <div style="display: flex;justify-content: flex-end;"><el-button type="primary" size="mini"
              v-if="0">数据列表</el-button>
          </div>
        </div>
        <div class="border-line" style="width: 30%;margin-bottom: 20px;height: 420px;">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">单用户周均充电量</div>
            <div class="font-size14">(时间筛选周期内)</div>
          </div>
          <div style="
              display: flex;
              justify-content: flex-end;
              margin-top: 10px;
            ">
            <div>
              <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                size="mini" value-format="yyyy-MM-dd" v-model="dateListB" @change="getDateListB">
              </el-date-picker>
            </div>
          </div>
          <div ref="chartAG" style="width: 100%; height: 300px"></div>
          <div style="display: flex;justify-content: flex-end;"><el-button type="primary" size="mini"
              v-if="0">数据列表</el-button>
          </div>
        </div>
        <div class="border-line" style="width: 30%;margin-bottom: 20px;height: 420px;">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">累计充电电量统计</div>
            <div class="font-size14">(时间筛选周期内)</div>
          </div>
          <div style="
              display: flex;
              justify-content: flex-end;
              margin-top: 10px;
            ">
            <div>
              <el-date-picker type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                size="mini" value-format="yyyy-MM-dd" v-model="dateListC" @change="getDateListC">
              </el-date-picker>
            </div>
          </div>
          <div ref="chartAH" style="width: 100%; height: 300px"></div>
          <div style="display: flex;justify-content: flex-end;"><el-button type="primary" size="mini"
              v-if="0">数据列表</el-button>
          </div>
        </div>
      </div>
      <!-------------------------------------用户已绑桩数据统计（时间筛选周期内）------------------------------------------->
      <div class="item4-title">用户已绑桩数据统计<span class="font-size14">（时间筛选周期内）</span></div>
      <div class="content-item4 margin-bottom-16 border-line">
        <div class="item4-info">
          <div class="info-box">
            <div class="info-left">
              <div>已绑桩用户总数</div>
              <div>{{ hasBindPileUser.bindUserCount.toLocaleString() || 0 }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="info-left">
              <div>用户增量</div>
              <div>{{ hasBindPileUser.bindUserIncrement.toLocaleString() || 0 }}</div>
            </div>
          </div>
          <div class="info-box">
            <div class="info-left">
              <div>环比增长</div>
              <div>{{ hasBindPileUser.bindUserCountRatio || 0 }}%</div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-item1 margin-bottom-16">
        <div class="item2-left border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              累计已绑桩用户数渠道占比
            </div>
            <div>
              <el-button type="primary" size="mini" v-if="0">数据列表</el-button>
            </div>
          </div>
          <div id="chartAI" style="width: 100%; height: 300px" ref="chartAI"></div>
        </div>
        <div class="item2-right border-line">
          <div style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="font-deep font-size16">
              累计各渠道已绑桩用户数及增量数据统计<span class="font-size14" style="margin-left: 15px">(时间筛选周期内)</span>
            </div>
            <div>
              <el-button type="primary" size="mini" v-if="0">数据列表</el-button>
            </div>
          </div>
          <div id="chartAJ" style="width: 100%; height: 350px" ref="chartAJ"></div>
        </div>
      </div>
      <!-------------------------------------绑定用户数据统计（支付宝激励）------------------------------------------->
      <div class="item4-title">绑定用户数据统计（支付宝激励）</div>
      <div class="content-item6 margin-bottom-16 border-line">
        <div class="item6-left">
          <div class="left-top">
            <div class="item6-title">绑定用户数据统计</div>
            <div class="item6-info">
              <div class="info-list">
                <div class="list-first">{{ bindList.bindUserTotal }}</div>
                <div class="list-second">已绑桩用户数（总数）</div>
              </div>
              <div class="info-list">
                <div class="list-third">
                  较{{
                    queryInfo.dateType === 0
                      ? "前一天"
                      : queryInfo.dateType === 1
                        ? "上个月"
                        : queryInfo.dateType === 2
                          ? "上周期"
                          : "-"
                  }}
                  环比 <span>{{ bindList.chainRatio }} %</span>
                </div>
                <div class="list-fourth">
                  {{
                    queryInfo.dateType === 0
                      ? "前一天"
                      : queryInfo.dateType === 1
                        ? "上个月"
                        : queryInfo.dateType === 2
                          ? "上周期"
                          : "-"
                  }}增量 <span>{{ bindList.bindUserIncrement }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="left-chart-box">
            <div class="chart-box-info">
              <div class="item6-title">各渠道绑定用户总数占比饼图</div>
              <div class="chart-first" id="bind-first"></div>
            </div>
            <div class="chart-box-info">
              <div class="item6-title">各渠道绑定用户增量占比饼图</div>
              <div class="chart-second" id="bind-second"></div>
            </div>
          </div>
        </div>
        <div class="item6-right">
          <el-table class="el-table" :data="bindTotalList" border style="width: 100%; margin-bottom: 20px"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column prop="name" label="绑定用户数（总量）" />
            <el-table-column prop="bindA" label="支付宝公域扫码绑定（总数）" />
            <el-table-column prop="bindB" label="APP/小程序绑定用户数（总数）" />
            <el-table-column prop="bindC" label="已绑桩数据推送至支付宝用户数（总数）" />
            <el-table-column prop="bindD" label="APP绑定推送成功（总数）" />
            <el-table-column prop="bindE" label="一键登录绑定推送成功（总数）" />
          </el-table>
          <el-table class="el-table" :data="bindIncrementList" border style="width: 100%"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column prop="name" label="绑定用户数（增量）" />
            <el-table-column prop="bindA" label="支付宝公域扫码绑定（增量）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.bindA
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.bindA) >= 0 ? '#7aec7e' : '#ea7281',
                }">{{ scope.row.bindA }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bindB" label="APP/小程序绑定用户数（增量）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.bindB
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.bindB) >= 0 ? '#7aec7e' : '#ea7281',
                }">{{ scope.row.bindB }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bindC" label="已绑桩数据推送至支付宝用户数（增量 ）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.bindC
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.bindC) >= 0 ? '#7aec7e' : '#ea7281',
                }">{{ scope.row.bindC }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bindD" label="APP绑定推送成功（增量 ）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.bindD
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.bindD) >= 0 ? '#7aec7e' : '#ea7281',
                }">{{ scope.row.bindD }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="bindE" label="一键登录绑定推送成功（增量 ）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.bindE
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.bindE) >= 0 ? '#7aec7e' : '#ea7281',
                }">{{ scope.row.bindE }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>






      <!--
      <div class="content-item2 margin-bottom-16 border-line">
        <div class="item2-title">活动落地 {{ queryInfo.pageType === 'A_TYPE' ? 'A' : 'B' }} 页数据统计</div>
        <div class="item2-info">
          <div class="info-box">
            <div>累计进入活动页人数</div>
            <div>{{ formList.totalEntryCount }}</div>
            <div>较前一周 环比 <span>{{ formList.totalGrowRate }} %</span></div>
            <div>前一周增量 {{ formList.totalEntryCountIncrement }}</div>
          </div>
          <div class="info-symbol">≈</div>
          <div class="info-box">
            <div>微信进入活动页人数</div>
            <div>{{ formList.wechatEntryCount }}</div>
            <div>较前一周 环比 <span>{{ formList.wechatGrowthRate }} %</span></div>
            <div>前一周增量 {{ formList.wechatIncrement }}</div>
          </div>
          <div class="info-symbol">+</div>
          <div class="info-box">
            <div>支付宝进入活动页人数</div>
            <div>{{ formList.alipayEntryCount }}</div>
            <div>较前一周 环比 <span>{{ formList.alipayGrowthRate }} %</span></div>
            <div>前一周增量 {{ formList.alipayIncrement }}</div>
          </div>
          <div class="info-symbol">+</div>
          <div class="info-box">
            <div>小红书进入活动页人数</div>
            <div>{{ formList.xiaohongshuEntryCount }}</div>
            <div>较前一周 环比 <span>{{ formList.xiaohongshuGrowthRate }} %</span></div>
            <div>前一周增量 {{ formList.xiaohongshuIncrement }}</div>
          </div>
          <div class="info-symbol">+</div>
          <div class="info-box">
            <div>抖音进入活动页人数</div>
            <div>{{ formList.douyinEntryCount }}</div>
            <div>较前一周 环比 <span>{{ formList.douyinGrowthRate }} %</span></div>
            <div>前一周增量 {{ formList.douyinIncrement }}</div>
          </div>
        </div>
      </div>
      -->
      <!--
      <div class="content-item3 margin-bottom-16 border-line">
        <div class="item3-title">活动流程数据统计</div>
        <div class="item3-info">
          <div class="info-box">
            <div>{{ formList.zeroYuanOrderClickUserCount }}</div>
            <div>0元下单人数</div>
            <div>较前一周 环比 <span>{{ formList.zeroYuanOrderClickGrowthRate }} %</span></div>
          </div>
          <div class="info-symbol">→</div>
          <div class="info-box">
            <div>{{ formList.enterUserAgreementCount }}</div>
            <div>进入用户协议人数</div>
            <div>较前一周 环比 <span>{{ formList.enterUserAgreementGrowthRate }} %</span></div>
          </div>
          <div class="info-symbol">→</div>
          <div class="info-box">
            <div>{{ formList.clickAgreeButtonCount }}</div>
            <div>点击阅读并同意按钮用户数</div>
            <div>较前一周 环比 <span>{{ formList.clickAgreeButtonGrowthRate }} %</span></div>
          </div>
          <div class="info-symbol">→</div>
          <div class="info-box">
            <div>{{ formList.successfulRegistrationCount }}</div>
            <div>活动成功报名人数</div>
            <div>较前一周 环比 <span>{{ formList.successfulRegistrationGrowthRate }} %</span></div>
          </div>
        </div>
      </div>
      -->



      <div class="content-item5 margin-bottom-16 border-line" v-if="0">
        <div class="item5-chart">
          <div class="item5-title">不安装原因数据占比饼图</div>
          <div class="registration-trends" id="RegistrationTrends"></div>
        </div>
        <div class="item5-table">
          <div class="item5-title">不安装原因数据统计</div>
          <el-table class="el-table" :data="notInstallList" border height="480" style="width: 100%"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column prop="reason" label="不安装原因" />
            <el-table-column prop="orderNumber" label="订单数量" />
            <el-table-column prop="percentage" label="占比">
              <template slot-scope="scope">
                {{ scope.row.percentage }} %
              </template>
            </el-table-column>
            <el-table-column prop="chainRatio" :label="`${queryInfo.dateType === 0
              ? '前一天'
              : queryInfo.dateType === 1
                ? '上个月'
                : queryInfo.dateType === 2
                  ? '上周期'
                  : '-'
              }环比`">
              <template slot-scope="scope">
                <span :style="{
                  color: scope.row.chainRatio >= 0 ? '#7aec7e' : '#ea7281',
                }">
                  {{ scope.row.chainRatio }} %</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>

      <div class="content-item6 margin-bottom-16 border-line" v-if="0">
        <div class="item6-left">
          <div class="left-top">
            <div class="item6-title">安装情况数据统计</div>
            <div class="item6-info">
              <div class="info-list">
                <div class="list-first">
                  {{ installList.investigationFinishedNotInstallTotal }}
                </div>
                <div class="list-second">已上门勘察不安装数量（总数）</div>
              </div>
              <div class="info-list">
                <div class="list-third">
                  较{{
                    queryInfo.dateType === 0
                      ? "前一天"
                      : queryInfo.dateType === 1
                        ? "上个月"
                        : queryInfo.dateType === 2
                          ? "上周期"
                          : "-"
                  }}
                  环比
                  <span>{{
                    installList.investigationFinishedNotInstallChainRatio
                  }}
                    %</span>
                </div>
                <div class="list-fourth">
                  {{
                    queryInfo.dateType === 0
                      ? "前一天"
                      : queryInfo.dateType === 1
                        ? "上个月"
                        : queryInfo.dateType === 2
                          ? "上周期"
                          : "-"
                  }}增量
                  <span>{{
                    installList.investigationInitNotInstallIncrement
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="left-chart-box">
            <div class="chart-box-info">
              <div class="item6-title">安装包各米数总量占比</div>
              <div class="chart-first" id="install-first"></div>
            </div>
            <div class="chart-box-info">
              <div class="item6-title">安装包各米数增量占比</div>
              <div class="chart-second" id="install-second"></div>
            </div>
          </div>
        </div>
        <div class="item6-right">
          <el-table class="el-table" :data="installTotalList" border style="width: 100%; margin-bottom: 20px"
            :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column prop="name" label="安装包（总量）" />
            <el-table-column prop="TEN_METER" label="安装包10米（总量）" />
            <el-table-column prop="TWENTY_METER" label="安装包20米（总量）" />
            <el-table-column prop="THIRTY_METER" label="安装包30米（总量）" />
            <el-table-column prop="FORTY_METER" label="安装包40米（总量）" />
          </el-table>
          <el-table class="el-table" :data="installIncrementList" border :cell-style="{ 'text-align': 'center' }"
            :header-cell-style="{
              background: '#FAFAFA',
              color: '#8F9BB3',
              fontSize: '14px',
              textAlign: 'center',
              border: '1px solid #F0F0F0',
            }">
            <el-table-column prop="name" label="安装包（增量）" />
            <el-table-column prop="TEN_METER" label="安装包10米（增量）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.TEN_METER
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.TEN_METER) >= 0
                      ? '#7aec7e'
                      : '#ea7281',
                }">{{ scope.row.TEN_METER }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="TWENTY_METER" label="安装包20米（增量）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.TWENTY_METER
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.TWENTY_METER) >= 0
                      ? '#7aec7e'
                      : '#ea7281',
                }">{{ scope.row.TWENTY_METER }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="THIRTY_METER" label="安装包30米（增量）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.THIRTY_METER
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.THIRTY_METER) >= 0
                      ? '#7aec7e'
                      : '#ea7281',
                }">{{ scope.row.THIRTY_METER }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="FORTY_METER" label="安装包40米（增量）">
              <template slot-scope="scope">
                <span v-if="scope.row.name != '上周期环比'">{{
                  scope.row.FORTY_METER
                }}</span>
                <span v-else :style="{
                  color:
                    parseFloat(scope.row.FORTY_METER) >= 0
                      ? '#7aec7e'
                      : '#ea7281',
                }">{{ scope.row.FORTY_METER }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>



      <div class="content-item7 margin-bottom-16 border-line" v-if="0">
        <div class="item7-title">充电数据统计</div>

        <div class="item7-info">
          <div class="item7-left">
            <div class="left-list">
              <div>{{ chargeList.avgChargeTimes }} 次</div>
              <div>已绑桩用户平均充电次数</div>
            </div>
            <div class="left-list">
              <div>￥ {{ chargeList.shareOrderIncome }}</div>
              <div>私桩共享订单收益</div>
            </div>
          </div>

          <div class="item7-right">
            <el-table class="el-table" :data="chargeTotalList" border style="width: 100%; margin-bottom: 20px"
              :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
                background: '#FAFAFA',
                color: '#8F9BB3',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #F0F0F0',
              }">
              <el-table-column prop="name" label="充电订单（总量）" />
              <el-table-column prop="chargeA" label="私桩充电订单（总量）" />
              <el-table-column prop="chargeB" label="私桩充电电量（总量）" />
              <el-table-column prop="chargeC" label="私桩共享订单（总量）" />
              <el-table-column prop="chargeD" label="私桩共享订单充电量（总量）" />
            </el-table>
            <el-table class="el-table" :data="chargeIncrementList" border style="width: 100%"
              :cell-style="{ 'text-align': 'center' }" :header-cell-style="{
                background: '#FAFAFA',
                color: '#8F9BB3',
                fontSize: '14px',
                textAlign: 'center',
                border: '1px solid #F0F0F0',
              }">
              <el-table-column prop="name" label="充电订单（增量）" />
              <el-table-column prop="chargeA" label="私桩充电订单（增量）">
                <template slot-scope="scope">
                  <span v-if="scope.row.name != '上周期环比'">{{
                    scope.row.chargeA
                  }}</span>
                  <span v-else :style="{
                    color:
                      parseFloat(scope.row.chargeA) >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">{{ scope.row.chargeA }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="chargeB" label="私桩充电电量（增量）">
                <template slot-scope="scope">
                  <span v-if="scope.row.name != '上周期环比'">{{
                    scope.row.chargeB
                  }}</span>
                  <span v-else :style="{
                    color:
                      parseFloat(scope.row.chargeB) >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">{{ scope.row.chargeB }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="chargeC" label="私桩共享订单（增量）">
                <template slot-scope="scope">
                  <span v-if="scope.row.name != '上周期环比'">{{
                    scope.row.chargeC
                  }}</span>
                  <span v-else :style="{
                    color:
                      parseFloat(scope.row.chargeC) >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">{{ scope.row.chargeC }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="chargeD" label="私桩共享订单充电量（增量）">
                <template slot-scope="scope">
                  <span v-if="scope.row.name != '上周期环比'">{{
                    scope.row.chargeD
                  }}</span>
                  <span v-else :style="{
                    color:
                      parseFloat(scope.row.chargeD) >= 0
                        ? '#7aec7e'
                        : '#ea7281',
                  }">{{ scope.row.chargeD }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageConfig from "./page-config";
import * as echarts from 'echarts';
export default {
  data() {
    return {
      pageConfig: pageConfig,
      showMultiQuery: false,
      activeSelectList: [
        { label: "活动AB页面", value: "" },
        { label: "活动A页面", value: "A_TYPE" },
        { label: "活动B页面", value: "B_TYPE" },
      ],
      formList: {}, // 活动落地页数据统计、活动流程数据统计
      tableKey: 0,
      props: { multiple: true },
      treeData: [
        {
          value: 'all',
          label: "全渠道累计",
          children: [
            {
              value: 'zdj',
              label: "桩到家累计",
              children: [
                {
                  value: 11,
                  label: "桩到家服务号",
                },
                {
                  value: 12,
                  label: "桩到家服务号菜单",
                },
                {
                  value: 7,
                  label: "桩到家微信小程序",
                },
                {
                  value: 8,
                  label: "桩到家支付宝小程序",
                },
                {
                  value: 9,
                  label: "桩到家APP",
                },
                {
                  value: 10,
                  label: "桩到家PC",
                },
                {
                  value: 17,
                  label: "桩到家微信H5",
                },
              ]
            },
            {
              value: 'zd',
              label: "挚达累计",
              children: [
                {
                  value: 13,
                  label: "朋友圈",
                },
                {
                  value: 6,
                  label: "挚达APP",
                },
                {
                  value: 14,
                  label: "挚达微信公众号",
                },
                {
                  value: 4,
                  label: "支付宝车生活公充",
                },
                {
                  value: 5,
                  label: "支付宝家充",
                },
                {
                  value: 1,
                  label: "支付宝私域",
                },
              ]
            },
            {
              value: 'sanfang',
              label: "第三方累计",
              children: [
                {
                  value: 2,
                  label: "小红书",
                },
                {
                  value: 3,
                  label: "抖音",
                },
              ]
            }
          ]
        },
      ],
      channelList: [
        {
          name: "数据累计",
          id: 1,
          apvCount: 0,
          apvInc: 0,
          apvRatio: 0,
          browseAgreementCount: 0,
          browseAgreementInc: 0,
          browseAgreementRatio: 0,
          browseAgreementUserCount: 0,
          browseAgreementUserInc: 0,
          browseAgreementUserRatio: 0,
          createOrderCount: 0,
          createOrderInc: 0,
          createOrderRatio: 0,
          fdaCount: 0,
          fdaInc: 0,
          fdaRatio: 0,
          knowMoreCount: 0,
          knowMoreInc: 0,
          knowMoreRatio: 0,
          mdaCount: 0,
          mdaInc: 0,
          mdaRatio: 0,
          rauCount: 0,
          rauInc: 0,
          rauRatio: 0,
          rauUserCount: 0,
          rauUserInc: 0,
          rauUserRatio: 0,
          sbcCount: 0,
          sbcInc: 0,
          sbcRatio: 0,
          sbcUserCount: 0,
          sbcUserInc: 0,
          sbcUserRatio: 0,
          signDirectlyCount: 0,
          signDirectlyInc: 0,
          signDirectlyRatio: 0,
          signMessageCount: 0,
          signMessageInc: 0,
          signMessageRatio: 0,
          sscCount: 0,
          sscInc: 0,
          sscRatio: 0,
          zocCount: 0,
          zocInc: 0,
          zocRatio: 0,
        },
        {
          name: "桩到家",
          id: 2,
          apvCount: 0,
          apvInc: 0,
          apvRatio: 0,
          browseAgreementCount: 0,
          browseAgreementInc: 0,
          browseAgreementRatio: 0,
          browseAgreementUserCount: 0,
          browseAgreementUserInc: 0,
          browseAgreementUserRatio: 0,
          createOrderCount: 0,
          createOrderInc: 0,
          createOrderRatio: 0,
          fdaCount: 0,
          fdaInc: 0,
          fdaRatio: 0,
          knowMoreCount: 0,
          knowMoreInc: 0,
          knowMoreRatio: 0,
          mdaCount: 0,
          mdaInc: 0,
          mdaRatio: 0,
          rauCount: 0,
          rauInc: 0,
          rauRatio: 0,
          rauUserCount: 0,
          rauUserInc: 0,
          rauUserRatio: 0,
          sbcCount: 0,
          sbcInc: 0,
          sbcRatio: 0,
          sbcUserCount: 0,
          sbcUserInc: 0,
          sbcUserRatio: 0,
          signDirectlyCount: 0,
          signDirectlyInc: 0,
          signDirectlyRatio: 0,
          signMessageCount: 0,
          signMessageInc: 0,
          signMessageRatio: 0,
          sscCount: 0,
          sscInc: 0,
          sscRatio: 0,
          zocCount: 0,
          zocInc: 0,
          zocRatio: 0,
          children: [
            {
              id: 5,
              name: "",
            },
          ],
        },
        {
          name: "挚达",
          id: 3,
          apvCount: 0,
          apvInc: 0,
          apvRatio: 0,
          browseAgreementCount: 0,
          browseAgreementInc: 0,
          browseAgreementRatio: 0,
          browseAgreementUserCount: 0,
          browseAgreementUserInc: 0,
          browseAgreementUserRatio: 0,
          createOrderCount: 0,
          createOrderInc: 0,
          createOrderRatio: 0,
          fdaCount: 0,
          fdaInc: 0,
          fdaRatio: 0,
          knowMoreCount: 0,
          knowMoreInc: 0,
          knowMoreRatio: 0,
          mdaCount: 0,
          mdaInc: 0,
          mdaRatio: 0,
          rauCount: 0,
          rauInc: 0,
          rauRatio: 0,
          rauUserCount: 0,
          rauUserInc: 0,
          rauUserRatio: 0,
          sbcCount: 0,
          sbcInc: 0,
          sbcRatio: 0,
          sbcUserCount: 0,
          sbcUserInc: 0,
          sbcUserRatio: 0,
          signDirectlyCount: 0,
          signDirectlyInc: 0,
          signDirectlyRatio: 0,
          signMessageCount: 0,
          signMessageInc: 0,
          signMessageRatio: 0,
          sscCount: 0,
          sscInc: 0,
          sscRatio: 0,
          zocCount: 0,
          zocInc: 0,
          zocRatio: 0,
          children: [
            {
              id: 9,
              name: "",
            },
          ],
        },
        {
          name: "第三方",
          id: 4,
          apvCount: 0,
          apvInc: 0,
          apvRatio: 0,
          browseAgreementCount: 0,
          browseAgreementInc: 0,
          browseAgreementRatio: 0,
          browseAgreementUserCount: 0,
          browseAgreementUserInc: 0,
          browseAgreementUserRatio: 0,
          createOrderCount: 0,
          createOrderInc: 0,
          createOrderRatio: 0,
          fdaCount: 0,
          fdaInc: 0,
          fdaRatio: 0,
          knowMoreCount: 0,
          knowMoreInc: 0,
          knowMoreRatio: 0,
          mdaCount: 0,
          mdaInc: 0,
          mdaRatio: 0,
          rauCount: 0,
          rauInc: 0,
          rauRatio: 0,
          rauUserCount: 0,
          rauUserInc: 0,
          rauUserRatio: 0,
          sbcCount: 0,
          sbcInc: 0,
          sbcRatio: 0,
          sbcUserCount: 0,
          sbcUserInc: 0,
          sbcUserRatio: 0,
          signDirectlyCount: 0,
          signDirectlyInc: 0,
          signDirectlyRatio: 0,
          signMessageCount: 0,
          signMessageInc: 0,
          signMessageRatio: 0,
          sscCount: 0,
          sscInc: 0,
          sscRatio: 0,
          zocCount: 0,
          zocInc: 0,
          zocRatio: 0,
          children: [
            {
              id: 14,
              name: "",
            },
          ],
        },
      ], // 渠道数据统计
      contentList: {}, // 联系用户数据统计
      notInstallList: [], // 不安装原因数据
      installList: {}, // 安装情况数据
      installTotalList: [], // 安装情况数据 - 总量表格
      installIncrementList: [], // 安装情况数据 - 增量表格
      bindList: {}, // 绑定用户数据统计
      bindTotalList: [], // 绑定用户数据统计 - 总量表格
      bindIncrementList: [], // 绑定用户数据统计 - 增量表格

      chargeList: {}, // 充电数据统计
      chargeTotalList: [], // 充电数据统计 - 总量表格
      chargeIncrementList: [], // 充电数据统计 - 增量表格

      dateStr: "",
      queryInfo: {
        dateType: 0,
        dateStr: "",
        pageType: "",
      },
      dataOverviewQuery: {
        dateType: 0,
        dateStr: "",
        dateEndStr: "",
        pageType: "",
      },
      customType: 0, // 渠道类型 0-日 1-月 2-周 3-自定义
      doubleDateList: [],
      singleDate: '',
      dataOverviewFormList: {
        viewCount: 0,
        createUserCount: 0,
        signedUserCount: 0,
        bindPileUserCount: 0,
        exitUserCount: 0,
        createCount: 0,
        clickSignUserCount: 0,
        validSignUserCount: 0
      },
      channelCodeList: [],
      codeList: [],
      currentStep: '进入活动页浏览次数',
      stepChannelList: [],
      optionAB: {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            type: "bar",
            barWidth: "60%",
            data: [],
          },
        ],
      },
      chartAB: '',
      userInstallData: {
        installUserCount: 0,
        contactedUserCount: 0,
        noInstallUserCount: 0,
      },
      userChargingData: {
        chargeOrderCount: 0,
        chargeElecTotal: 0,
        serviceFeeTotal: 0,
        weeklyAvgChargeCount: 0,
        avgChargeElec: 0,
      },
      dateListA: [],
      dateListB: [],
      dateListC: [],
      dateQueryA: {
        dateStr: "",
        dateEndStr: "",
      },
      dateQueryB: {
        dateStr: "",
        dateEndStr: "",
      },
      dateQueryC: {
        dateStr: "",
        dateEndStr: "",
      },
      hasBindPileUser: {
        bindUserCount: 0,
        bindUserIncrement: 0,
        bindUserCountRatio: 0,
      },
    };
  },
  mounted() {
    // 当前日期并格式化
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;

    // 获取7天前的日期
    const sevenDaysAgo = new Date();
    // 减去7天的毫秒数（7天 * 24小时 * 60分钟 * 60秒 * 1000毫秒）
    sevenDaysAgo.setTime(sevenDaysAgo.getTime() - 7 * 24 * 60 * 60 * 1000);
    const newyear = sevenDaysAgo.getFullYear();
    const newmonth = String(sevenDaysAgo.getMonth() + 1).padStart(2, '0');
    const newday = String(sevenDaysAgo.getDate()).padStart(2, '0');
    const newformattedDate = `${newyear}-${newmonth}-${newday}`;

    this.singleDate = formattedDate;

    this.dateQueryA.dateStr = newformattedDate
    this.dateQueryA.dateEndStr = formattedDate
    this.dateListA = [newformattedDate, formattedDate]

    this.dateQueryB.dateStr = newformattedDate
    this.dateQueryB.dateEndStr = formattedDate
    this.dateListB = [newformattedDate, formattedDate]

    this.dateQueryC.dateStr = newformattedDate
    this.dateQueryC.dateEndStr = formattedDate
    this.dateListC = [newformattedDate, formattedDate]

    this.dataOverviewQuery.dateStr = formattedDate;

    this.codeList = this.convertTreeToPaths(this.treeData)

    this.channelCodeList = this.codeList.map(item => item[2])
    this.init();
    this.getAvgChargeCount()
    this.getWeeklyAvgChargeElec()
    this.getTotalChargeElec()

  },
  methods: {
    toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      // if (process.env.NODE_ENV == 'development') {
      //   urls = 'http://192.168.8.174:7997'
      // } else {
      //   urls = 'http://ocharge.shzhida.com:6777'
      // }
      _.$H
        .post(_, _.$A.zeroOrder.list17, _.dataOverviewQuery)
        .then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = urls + res.data.data.filePath;
          window.open(downUrl, "_blank");
          _.$U.hideLoading(_);
        });
    },
    getDateListA(val) {
      if (val == null) {
        this.$U.error("请选择时间");
        return
      } else {
        this.dateQueryA.dateStr = val[0];
        this.dateQueryA.dateEndStr = val[1];
        this.getAvgChargeCount()
      }
    },
    getDateListB(val) {
      if (val == null) {
        this.$U.error("请选择时间");
        return
      } else {
        this.dateQueryB.dateStr = val[0];
        this.dateQueryB.dateEndStr = val[1];
        this.getWeeklyAvgChargeElec()
      }
    },
    getDateListC(val) {
      if (val == null) {
        this.$U.error("请选择时间");
        return
      } else {
        this.dateQueryC.dateStr = val[0];
        this.dateQueryC.dateEndStr = val[1];
        this.getTotalChargeElec()
      }
    },
    // 单用户周均充电次数
    getAvgChargeCount() {
      let _ = this;
      _.$H.post(_, _.$A.zeroOrder.list13, _.dateQueryA).then((res) => {
        let resp = res.data.data || {};
        // 单用户周均充电次数
        let chartAF = this.$echarts.init(this.$refs.chartAF);
        let optionAF = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: resp.meterLine.map(item => item.xAxis),
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          grid: {
            bottom: '10%',
            left: '0%',
            right: '0%'
          },
          series: [
            {
              type: 'line',
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(79,144,236,.9)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(79,144,236,.1)'
                  }
                ])
              },
              lineStyle: {
                color: '#4f90ec'
              },
              itemStyle: {
                color: '#4f90ec'
              },
              emphasis: {
                focus: 'series'
              },
              smooth: true,
              data: resp.meterLine.map(item => item.weeklyAvgChargeCount),
            },
          ]
        }
        chartAF.setOption(optionAF);
        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAF.resize();
          });
        }, 500)
      });

    },
    // 单用户周均充电量
    getWeeklyAvgChargeElec() {
      let _ = this;
      _.$H.post(_, _.$A.zeroOrder.list14, _.dateQueryB).then((res) => {
        let resp = res.data.data || {};
        let chartAG = this.$echarts.init(this.$refs.chartAG);
        let optionAG = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            bottom: '10%',
            left: '0%',
            right: '0%'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: resp.meterLine.map(item => item.xAxis),
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              type: 'line',
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(123,176,116,.9)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(123,176,116,.1)'
                  }
                ])
              },
              lineStyle: {
                color: '#7bb074'
              },
              itemStyle: {
                color: '#7bb074'
              },
              emphasis: {
                focus: 'series'
              },
              smooth: true,
              data: resp.meterLine.map(item => item.chargeElec),
            },
          ]
        }
        chartAG.setOption(optionAG);
        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAG.resize();
          });
        }, 500)
      });

    },
    // 累计充电量统计
    getTotalChargeElec() {
      let _ = this;
      _.$H.post(_, _.$A.zeroOrder.list15, _.dateQueryC).then((res) => {
        let resp = res.data.data || {};
        let chartAH = this.$echarts.init(this.$refs.chartAH);
        let optionAH = {
          title: {
            text: ''
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          grid: {
            bottom: '10%',
            left: '0%',
            right: '0%'
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: resp.meterLine.map(item => item.xAxis),
            }
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: [
            {
              type: 'line',
              areaStyle: {
                opacity: 0.8,
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: 'rgba(235,210,125,.9)'
                  },
                  {
                    offset: 1,
                    color: 'rgba(235,210,125,.1)'
                  }
                ])
              },
              lineStyle: {
                color: '#ebd27d'
              },
              itemStyle: {
                color: '#ebd27d'
              },
              emphasis: {
                focus: 'series'
              },
              smooth: true,
              data: resp.meterLine.map(item => item.chargeElec),
            },
          ]
        }
        chartAH.setOption(optionAH);
        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAH.resize();
          });
        }, 500)
      });

    },
    restQuery() {
      this.customType = 0;
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;
      this.singleDate = formattedDate;
      this.dataOverviewQuery.dateType = 0;
      this.dataOverviewQuery.dateEndStr = '';
      this.dataOverviewQuery.dateStr = formattedDate;
      this.codeList = this.convertTreeToPaths(this.treeData)
      this.channelCodeList = this.codeList.map(item => item[2])
      this.init();
    },
    currentStepChange() {
      let yData = []
      if (this.currentStep == '进入活动页浏览次数') {
        yData = this.stepChannelList.map(item => item.apvCount)
      } else if (this.currentStep == '0元下单点击次数') {
        yData = this.stepChannelList.map(item => item.zocCount)
      } else if (this.currentStep == '0元下单报名成功人数') {
        yData = this.stepChannelList.map(item => item.createOrderCount)
      } else if (this.currentStep == '点击直接签约人数') {
        yData = this.stepChannelList.map(item => item.signDirectlyCount)
      } else if (this.currentStep == '点击了解更多人数') {
        yData = this.stepChannelList.map(item => item.knowMoreCount)
      } else if (this.currentStep == '签约短信点击次数') {
        yData = this.stepChannelList.map(item => item.signMessageCount)
      } else if (this.currentStep == '活动签约按钮点击次数') {
        yData = this.stepChannelList.map(item => item.sbcCount)
      } else if (this.currentStep == '活动签约按钮点击人数') {
        yData = this.stepChannelList.map(item => item.sbcUserCount)
      } else if (this.currentStep == '点击阅读并签署按钮次数') {
        yData = this.stepChannelList.map(item => item.rauCount)
      } else if (this.currentStep == '点击阅读并签署人数') {
        yData = this.stepChannelList.map(item => item.rauUserCount)
      } else if (this.currentStep == '服务协议页面浏览次数') {
        yData = this.stepChannelList.map(item => item.browseAgreementCount)
      } else if (this.currentStep == '服务协议页面浏览人数') {
        yData = this.stepChannelList.map(item => item.browseAgreementUserCount)
      } else if (this.currentStep == '免押协议签约人数') {
        yData = this.stepChannelList.map(item => item.fdaCount)
      } else if (this.currentStep == '商家扣款协议签约人数') {
        yData = this.stepChannelList.map(item => item.mdaCount)
      } else if (this.currentStep == '活动成功签约人数') {
        yData = this.stepChannelList.map(item => item.sscCount)
      }
      this.optionAB.series[0].data = yData
      this.chartAB.setOption(this.optionAB);
    },
    doubleDateChange(val) {
      console.log(val)
      if (val == null) {
        this.$U.error("请选择时间");
        return
      } else {
        this.dataOverviewQuery.dateStr = val[0];
        this.dataOverviewQuery.dateEndStr = val[1];
        this.getDataOverview() // 数据总览
        this.getUserParticipateActivity() // 用户参与活动关键流程趋势图
        this.getListData() // 渠道统计
        this.getUserBindPile()
      }
    },
    singleDateChange(val) {
      console.log(val)
      this.dataOverviewQuery.dateStr = val;
      this.getDataOverview() // 数据总览
      this.getUserParticipateActivity() // 用户参与活动关键流程趋势图
      this.getListData() // 渠道统计
      this.getUserBindPile()

    },
    handleSelectDateTypeValue(val) {
      this.customType = val;
      this.dataOverviewQuery.dateType = val;
      if (val == 0) { // 日
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        this.singleDate = formattedDate;
        this.dataOverviewQuery.dateStr = formattedDate;
        this.dataOverviewQuery.dateEndStr = '';
      } else if (val == 2) {  //周
        console.log('rrrrrr')
        console.log(this.singleDate)
        const dates = new Date();
        const year = dates.getFullYear();
        const month = String(dates.getMonth() + 1).padStart(2, '0');
        const day = String(dates.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        this.singleDate = formattedDate;
        console.log('rrrrrr')
        const date = new Date();
        // 复制日期对象以避免修改原对象
        const tempDate = new Date(date.getTime());

        // 将日期设置为星期四，因为ISO周从星期一开始，星期四在当前周内
        // 这样可以确保一年中的最后几天正确计入当年的最后一周
        tempDate.setDate(tempDate.getDate() + 4 - (tempDate.getDay() || 7));

        // 获取当年的第一天
        const yearStart = new Date(tempDate.getFullYear(), 0, 1);

        // 计算当前日期距离当年第一天的天数，再加3天（调整为周一为一周的开始）
        const dayOfYear = Math.floor((tempDate - yearStart) / 86400000) + 1;

        // 计算周数（取整数部分）
        const weekNumber = Math.ceil(dayOfYear / 7);
        this.dataOverviewQuery.dateStr = `${tempDate.getFullYear()}-${weekNumber}`;
        this.dataOverviewQuery.dateEndStr = '';
      } else if (val == 1) { // 月
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const formattedDate = `${year}-${month}`;
        this.singleDate = formattedDate;
        this.dataOverviewQuery.dateStr = formattedDate;
        this.dataOverviewQuery.dateEndStr = '';
      } else if (val == 3) { // 自定义
        this.dataOverviewQuery.dateStr = '';
        this.dataOverviewQuery.dateEndStr = '';
      }
      this.currentStep = '进入活动页浏览次数';
      if (val != 3) {
        this.getDataOverview()
        this.getUserParticipateActivity()
        this.getListData() // 渠道统计
        this.getUserBindPile()
      }

    },
    drawLoudouChart() {
      // 漏斗图
      let loudouChart = this.$echarts.init(this.$refs.loudouEchart);

      var rightArrow =
        "image://data:image/png;base64,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",
        // var rightArrow = "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEkAAABNBAMAAAAYzFT5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAElBMVEUAAACZmZmZmZmqqqqZmZkAAAClqsN/AAAAA3RSTlMAf4C/aSLHAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAFdJREFUSMftzbENgCAYROEDHMCCASwYwMQFKNh/JkOhHfnPxuq9+sud9FSuZac+qnUFhUKhUKi3raNQqJ/U7qgU7k1VHZWGo+qI62qWyvHjrFkqW0pHTG6J1zAklFuGvAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMC0wMi0wM1QxODo0OTo1NyswODowMJLTpqcAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjAtMDItMDNUMTg6NDk6NTcrMDg6MDDjjh4bAAAAAElFTkSuQmCC",
        uploadedDataURL = "/asset/get/s/data-1576742942370-X6JMK0GY.png",
        colors = [
          "#1cd389",
          "#668eff",
          "#ffc751",
          "#ff6e73",
          "#8683e6",
          "#fbb034",
        ],
        url =
          "image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAARCAMAAACLgl7OAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAaVBMVEUAAADBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcHBwcEAAAD45xibAAAAInRSTlMAmT6WJYwSfBMGZAFHmEgtkBeCCW0KAlI1k5QeiA10A1tc7ah1owAAAAFiS0dEAIgFHUgAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAB7SURBVCjPtZDZDoAgDAQXvA+8bwX1/3/SGKIBEd+cx07TdgtIiAF0/mygDvnAoYDr2b3nnjP8wOaDUG6J4ncfR9cdScpMzbJECZEXT1/kesyy0n1VPv6AulF908Kg6+9DWN/hjWGUfhpgYV5Ov8ywwgUhguODddtXvXIAjuUEs/70/t4AAAAldEVYdGRhdGU6Y3JlYXRlADIwMTktMTItMTZUMTU6MzM6MDkrMDg6MDCzL2BEAAAAJXRFWHRkYXRlOm1vZGlmeQAyMDE5LTEyLTE2VDE1OjMzOjA5KzA4OjAwwnLY+AAAAABJRU5ErkJggg==",
        markLineSetting = {
          normal: {
            show: true,
            backgroundColor: "#e4f5da",
            borderRadius: 4,
            color: "#333",
            verticalAlign: "middle",
            offset: [40, 0, 0, 0],
            fontSize: 14,
            padding: [3, 10, 5, 10],
            formatter: function (d) {
              if (d.value) {
                var ins = "{img1|} " + "{words|" + d.data.itemValue + "}";
                return ins;
              }
            },
            rich: {
              img1: {
                backgroundColor: {
                  image: uploadedDataURL,
                },
                width: 18,
                height: 16,
              },
              words: {
                color: "#333",
                position: "right",
                fontSize: 14,
                lineHeight: 20,
                padding: [0, 0, 5, 0],
              },
            },
          },
        };

      var lineargroup = [
        {
          value: 100,
          name: "页面浏览",
          oriname: "页面浏览",
          number: this.dataOverviewFormList.viewCount,
          percent: `${this.dataOverviewFormList.createRatio}%`, // 非必须，如果不需要，填充空字符串， 左侧的数据
        },
        {
          value: 80,
          name: "留资点击",
          oriname: "留资点击",
          number: this.dataOverviewFormList.createCount,
          percent: "18.35%", // 非必须，如果不需要，填充空字符串， 左侧的数据
        },
        {
          value: 60,
          name: "实际留资",
          oriname: "实际留资",
          number: this.dataOverviewFormList.createUserCount,
          percent: "19.56%", // 非必须，如果不需要，填充空字符串， 左侧的数据
        },
        {
          value: 40,
          name: "同意签约",
          oriname: "同意签约",
          number: this.dataOverviewFormList.clickSignUserCount,
          percent: "25.35%", // 非必须，如果不需要，填充空字符串， 左侧的数据
        },
        {
          value: 20,
          name: "签约成功",
          oriname: "签约成功",
          number: this.dataOverviewFormList.signedUserCount,
          percent: "65.35%", // 非必须，如果不需要，填充空字符串， 左侧的数据
        },
        {
          value: 20,
          name: "活动绑桩",
          oriname: "活动绑桩",
          number: this.dataOverviewFormList.bindPileUserCount,
          percent: "65.35%", // 非必须，如果不需要，填充空字符串， 左侧的数据
        },
      ];

      var data1 = [];
      var ydata = [];
      var xiaojiantou_data = [];
      for (var i = 0; i < lineargroup.length; i++) {
        var obj1 = {
          value: (100 / lineargroup.length) * (lineargroup.length - i),
          num: lineargroup[i].number,
          name: lineargroup[i].oriname,
        };
        var _jiantou = {
          value: 100,
        };
        data1.push(obj1);
        ydata.push(i + 1);
        xiaojiantou_data.push(_jiantou);
      }

      var _rightHeight =
        (600 - 30 * (lineargroup.length - 1)) / lineargroup.length + 17;

      //转化率数据
      var sdata = [`${this.dataOverviewFormList.createRatio}%`, `${this.dataOverviewFormList.createUserRatio}%`, `${this.dataOverviewFormList.clickSignUserRatio}%`, `${this.dataOverviewFormList.signedUserRatio}%`, `${this.dataOverviewFormList.bindPileRatio}%`];

      var arrowData = [
        {
          value: 0,
          itemValue: "50%",
          show: false,
          label: markLineSetting,
        },
      ];

      for (var i = 0; i < lineargroup.length - 1; i++) {
        var _objdd = {
          value: 365 - i * (50 / lineargroup.length),
          itemValue: sdata[i],
          label: markLineSetting,
        };
        arrowData.push(_objdd);
      }

      var option = {
        backgroundColor: "#ffffff",
        color: colors,
        grid: {
          top: "0",
          left: "15%",
          right: 35,
          height:
            ((500 - 20 * lineargroup.length) / lineargroup.length + 23) *
            (lineargroup.length - 1) -
            lineargroup.length,
          bottom: "10",
        },
        xAxis: [
          {
            show: false,
            inverse: true,
            position: "top",
          },
          {
            position: "bottom",
            show: false,
            min: 100,
            max: 200,
          },
        ],
        yAxis: [
          {
            top: "120",
            show: false,
            boundaryGap: false,
            inverse: true,
            type: "category",
            // min: '转化率1',
            data: ydata,
          },
        ],
        series: [
          {
            top: 0,
            type: "funnel",
            height: "500",
            gap: 20,
            minSize: 150,
            left: "20%",
            width: "58%",
            z: 3,
            label: {
              show: true,
              position: "inside",
              fontSize: "14",
              color: '#FFFFFF',
              formatter: function (d) {
                var ins = d.name + "{aa|} " + d.data.num;
                return ins;
              },
              rich: {
                aa: {
                  padding: [8, 0, 6, 0],
                },
              },
            },
            data: data1,
          },

          {
            top: "0",
            name: "youcejiantou",
            type: "pictorialBar",
            symbolPosition: "center",
            symbolSize: ["93", "" + _rightHeight],
            symbol: rightArrow,
            symbolClip: true,
            xAxisIndex: "1",
            z: 1,
            data: arrowData,
          },
        ],
      };
      loudouChart.setOption(option);
      setTimeout(() => {
        window.addEventListener("resize", function () {
          loudouChart.resize();
        });
      }, 500)
    },
    init() {
      let _ = this;
      // 日
      const today = new Date();
      const year = today.getFullYear();
      let month = today.getMonth() + 1;
      month = month < 10 ? "0" + month : month;
      let date = today.getDate();
      date = date < 10 ? "0" + date : date;
      _.queryInfo.dateStr = year + "-" + month + "-" + date;

      // _.queryInfo.dateStr = _.getCurrentWeek();
      _.getDataOverview(); // 数据总览
      _.getUserParticipateActivity() // 用户参与活动关键流程趋势图
      _.getListData(); // 渠道统计
      _.getUserBindPile() // 用户已绑桩数据统计
    },
    getUserBindPile() {
      let _ = this;
      _.$H.post(_, _.$A.zeroOrder.list16, _.dataOverviewQuery).then((res) => {
        _.hasBindPileUser = res.data.data || {};
        // 累计已绑桩用户数渠道占比 饼图
        let chartAI = this.$echarts.init(this.$refs.chartAI);
        let optionAI = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // 计算百分比
              let total = 0;
              _.hasBindPileUser.pieChartData.forEach(item => {
                total += item.value;
              });

              // 防止除零错误，当总数为0时显示0%
              let percentage = total === 0 ? '0.0' : ((params.value / total) * 100).toFixed(1);

              // 返回自定义的tooltip内容
              return `
                <div style="padding: 8px;">
                  <div style="font-weight: bold; margin-bottom: 8px; color: #333;">${params.name}</div>
                  <div style="color: #666;">
                    • ${params.name} ${params.value.toLocaleString()} ${percentage}%
                  </div>
                </div>
              `;
            },
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e4e7ed',
            borderWidth: 1,
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 50,
          },
          series: [
            {
              name: '已绑定用户数',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              padAngle: 5,
              itemStyle: {
                borderRadius: 10
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: _.hasBindPileUser.pieChartData
            }
          ]
        }
        chartAI.setOption(optionAI);
        // 累计各渠道已绑桩用户数及增量数据统计 柱状图
        let chartAJ = this.$echarts.init(this.$refs.chartAJ);
        let optionAJ = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            top: '15%',
          },
          legend: {
            bottom: "0%",
            left: "center",
          },
          xAxis: [
            {
              type: 'category',
              data: _.hasBindPileUser.barChartData.map(item => item.xAxis),
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: '总数',
              type: 'bar',
              data: _.hasBindPileUser.barChartData.map(item => item.count),
            },
            {
              name: '增量',
              type: 'bar',
              data: _.hasBindPileUser.barChartData.map(item => item.delta),
            },
          ]
        }
        chartAJ.setOption(optionAJ);
        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAI.resize();
            chartAJ.resize();
          });
        }, 500);
      })
    },
    getCurrentWeek() {
      const now = new Date();
      const startOfYear = new Date(now.getFullYear(), 0, 1);
      const pastDaysOfYear = (now - startOfYear) / 86400000 + 1; // 从年初到现在的天数
      const weekNumber = Math.ceil(
        (pastDaysOfYear + startOfYear.getDay() + 1) / 7
      ); // 当前周数
      return `${now.getFullYear()}-${String(weekNumber).padStart(2, "0")}`;
    },

    handleSelectDateType() {
      let _ = this;
      _.dateStr = "";
      _.queryInfo.dateStr = "";
    },
    // 查询数据总览
    getDataOverview() {
      let _ = this;
      // 数据概览
      _.$H.post(_, _.$A.zeroOrder.list8, _.dataOverviewQuery).then((res) => {
        _.dataOverviewFormList = res.data.data || {};
        _.drawLoudouChart()
      });
    },
    // 用户参与活动关键流程趋势图
    getUserParticipateActivity() {
      let _ = this;
      // 数据概览
      _.$H.post(_, _.$A.zeroOrder.list9, { ..._.dataOverviewQuery, channelCodeList: this.channelCodeList, operationStepCodeList: [1, 16, 7] }).then((res) => {
        console.log('KKKK')
        console.log(res.data.data);
        console.log('KKKK')
        let chartAK = this.$echarts.init(this.$refs.chartAK);
        let xData = res.data.data.lineList.map(item => item.xAxis)
        let seriesDataA = res.data.data.lineList.map(item => item.apvCount)
        let seriesDataB = res.data.data.lineList.map(item => item.createOrderCount)
        let seriesDataC = res.data.data.lineList.map(item => item.sscCount)
        let optionAK = {
          tooltip: {
            trigger: 'axis'
          },
          legend: {
            top: "0%",
            left: "center",
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '0%',
            top: '15%',
            containLabel: true
          },
          xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xData
          },
          yAxis: {
            type: 'value'
          },
          series: [
            {
              name: '进入活动页面浏览次数',
              type: 'line',
              smooth: true,
              data: seriesDataA
            },
            {
              name: '留资报名成功人数',
              type: 'line',
              smooth: true,
              data: seriesDataB
            },
            {
              name: '累计签约成功人数',
              type: 'line',
              smooth: true,
              data: seriesDataC
            },
          ]
        }
        chartAK.setOption(optionAK);
        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAK.resize();
          });
        }, 500);
      });
    },
    // 查询
    getListData() {
      let _ = this;

      // 渠道数据统计
      _.$H.post(_, _.$A.zeroOrder.list7, _.dataOverviewQuery).then((res) => {
        let list = res.data.data.resultList || [];
        console.log('hhhhhhh')
        console.log(list);
        console.log('hhhhhhh')
        let newList = [];
        let lineXData = []; // 渠道活动路径数据统计 X轴数据
        _.stepChannelList = res.data.data.resultList.slice(4);

        list[0].name = "数据累计";
        list[0].id = 1;

        list[1].name = "桩到家";
        list[1].id = 2;
        list[1].hasChildren = true;
        list[1].children = [];

        list[2].name = "挚达";
        list[2].id = 3;
        list[2].hasChildren = true;
        list[2].children = [];

        list[3].name = "第三方";
        list[3].id = 4;
        list[3].hasChildren = true;
        list[3].children = [];

        // 桩到家
        list[4].name = "桩到家微信小程序";
        list[4].id = 5;
        list[5].name = "桩到家支付宝小程序";
        list[5].id = 6;
        list[6].name = "桩到家APP";
        list[6].id = 7;
        list[7].name = "桩到家PC";
        list[7].id = 8;
        list[18].name = "桩到家微信H5";
        list[18].id = 19;


        // 挚达
        list[8].name = "挚达APP";
        list[8].id = 9;
        list[9].name = "挚达微信公众号";
        list[9].id = 10;
        list[10].name = "支付宝车生活公充";
        list[10].id = 11;
        list[11].name = "支付宝家充";
        list[11].id = 12;
        list[12].name = "支付宝私域";
        list[12].id = 13;

        // 其他
        list[13].name = "小红书";
        list[13].id = 14;
        list[14].name = "抖音";
        list[14].id = 15;

        //新增
        list[15].name = "桩到家服务号";
        list[15].id = 16;
        list[16].name = "桩到家服务号菜单";
        list[16].id = 17;
        list[17].name = "微信朋友圈";
        list[17].id = 18;


        lineXData = ['桩到家微信小程序', '桩到家支付宝小程序', '桩到家APP', '桩到家PC', '挚达APP', '挚达微信公众号', '支付宝车生活公充', '支付宝家充', '支付宝私域', '小红书', '抖音', '桩到家服务号', '桩到家服务号菜单', '微信朋友圈', '桩到家微信H5']


        newList[0] = list[0];
        newList[1] = list[1];
        newList[2] = list[2];
        newList[3] = list[3];
        _.channelList[0] = list[0];
        _.channelList[1] = list[1];
        _.channelList[2] = list[2];
        _.channelList[3] = list[3];

        _.$set(_.channelList[1], "children", [...(list.slice(4, 8) || []), list[16], list[15], list[18]]);

        _.$set(_.channelList[2], "children", [
          ...(list.slice(8, 13) || []),
          list[17],
        ]);
        _.$set(_.channelList[3], "children", list.slice(13, 15) || []);
        _.tableKey++; // 更新el-table表格数据


        // 各渠道成功报名的用户数占比 饼图
        let chartAA = this.$echarts.init(this.$refs.chartAA);
        let optionAA = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // 计算百分比
              let total = list[1].createOrderCount + list[2].createOrderCount + list[3].createOrderCount || 0;

              // 防止除零错误，当总数为0时显示0%
              let percentage = total === 0 ? '0.0' : ((params.value / total) * 100).toFixed(1);

              // 返回自定义的tooltip内容
              return `
                <div style="padding: 8px;">
                  <div style="font-weight: bold; margin-bottom: 8px; color: #333;">${params.name}</div>
                  <div style="color: #666;">
                    • ${params.name} ${params.value.toLocaleString()} 占比:${percentage}%
                  </div>
                </div>
              `;
            },
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e4e7ed',
            borderWidth: 1,
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            bottom: "0%",
            left: "center",
          },
          series: [
            {
              name: '成功报名人数',
              type: "pie",
              radius: ["40%", "60%"],
              avoidLabelOverlap: false,
              padAngle: 5,
              itemStyle: {
                borderRadius: 10,
              },
              label: {
                show: false,
                position: "center",
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: false,
              },
              data: [
                { value: list[1].createOrderCount, name: "桩到家" },
                { value: list[2].createOrderCount, name: "挚达" },
                { value: list[3].createOrderCount, name: "第三方" },
              ],
            },
          ],
        };
        chartAA.setOption(optionAA);

        // 渠道活动路径数据统计 折线图
        _.chartAB = _.$echarts.init(_.$refs.chartAB);
        _.optionAB.xAxis[0].data = lineXData;
        _.optionAB.series[0].data = _.stepChannelList.map(item => item.apvCount);
        _.chartAB.setOption(_.optionAB);


        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAA.resize();
            _.chartAB.resize();
          });
        }, 500);
      });

      // 用户安装数据统计-数据统计总览
      _.$H.post(_, _.$A.zeroOrder.list10, _.dataOverviewQuery).then((res) => {
        _.userInstallData = res.data.data || {};
      });


      // 不安装/不签约原因的报名订单数量占比
      _.$H.post(_, _.$A.zeroOrder.list11, _.dataOverviewQuery).then((res) => {
        let resp = res.data.data || {};
        // 不安装/不签约原因的报名订单数量占比 饼图
        let chartAC = this.$echarts.init(this.$refs.chartAC);
        let optionAC = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // 计算百分比
              let total = 0;
              resp.pieChart.forEach(item => {
                total += item.value;
              });

              // 防止除零错误，当总数为0时显示0%
              let percentage = total === 0 ? '0.0' : ((params.value / total) * 100).toFixed(1);

              // 返回自定义的tooltip内容
              return `
                <div style="padding: 8px;">
                  <div style="font-weight: bold; margin-bottom: 8px; color: #333;">${params.name}</div>
                  <div style="color: #666;">
                    • ${params.name} ${params.value.toLocaleString()} 占比: ${percentage}%
                  </div>
                </div>
              `;
            },
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e4e7ed',
            borderWidth: 1,
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 50,
          },
          series: [
            {
              name: '不安装原因',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              padAngle: 5,
              itemStyle: {
                borderRadius: 10
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: resp.pieChart
            }
          ]
        };
        chartAC.setOption(optionAC);
        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAC.resize();
          });
        }, 500);
      });


      // 安装米数统计 饼图和柱状图
      _.$H.post(_, _.$A.zeroOrder.list12, _.dataOverviewQuery).then((res) => {
        let resp = res.data.data || {};
        // 累计已完成安装的各项安装包长度(米数)订单数量占比 饼图
        let chartAD = this.$echarts.init(this.$refs.chartAD);
        let optionAD = {
          tooltip: {
            trigger: 'item',
            formatter: function (params) {
              // 计算百分比
              let total = 0;
              resp.pieChartData.forEach(item => {
                total += item.value;
              });

              // 防止除零错误，当总数为0时显示0%
              let percentage = total === 0 ? '0.0' : ((params.value / total) * 100).toFixed(1);

              // 返回自定义的tooltip内容
              return `
                <div style="padding: 8px;">
                  <div style="font-weight: bold; margin-bottom: 8px; color: #333;">${params.name}</div>
                  <div style="color: #666;">
                    • ${params.name} ${params.value.toLocaleString()} 占比: ${percentage}%
                  </div>
                </div>
              `;
            },
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderColor: '#e4e7ed',
            borderWidth: 1,
            textStyle: {
              fontSize: 14
            }
          },
          legend: {
            orient: 'vertical',
            right: 10,
            top: 50,
          },
          series: [
            {
              name: '订单量占比',
              type: 'pie',
              radius: ['40%', '70%'],
              avoidLabelOverlap: false,
              padAngle: 5,
              itemStyle: {
                borderRadius: 10
              },
              label: {
                show: false,
                position: 'center'
              },
              emphasis: {
                label: {
                  show: true,
                  fontSize: 20,
                  fontWeight: 'bold'
                }
              },
              labelLine: {
                show: false
              },
              data: resp.pieChartData
            }
          ]
        };
        chartAD.setOption(optionAD);

        // 已完成安装的各项安装包长度(米数)订单数量的统计 柱状图
        let chartAE = this.$echarts.init(this.$refs.chartAE);
        let optionAE = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              crossStyle: {
                color: '#999'
              }
            }
          },
          legend: {
            bottom: "0%",
            left: "center",
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '15%',
            top: '15%',
          },
          xAxis: [
            {
              type: 'category',
              data: resp.meterLine.map(item => item.xAxis),
              axisPointer: {
                type: 'shadow'
              }
            }
          ],
          yAxis: [
            {
              type: 'value',
            },
          ],
          series: [
            {
              name: '总数',
              type: 'bar',
              data: resp.meterLine.map(item => item.count),
            },
            {
              name: '增量',
              type: 'bar',
              data: resp.meterLine.map(item => item.delta),
            },
          ]
        };
        chartAE.setOption(optionAE);


        setTimeout(() => {
          window.addEventListener("resize", function () {
            chartAD.resize();
            chartAE.resize();
          });
        }, 500);
      })

      // 用户充电数据统计
      _.$H.post(_, _.$A.zeroOrder.list6, _.dataOverviewQuery).then((res) => {
        _.userChargingData = res.data.data || {};
      });

      // 绑定用户数据统计
      _.$H.post(_, _.$A.zeroOrder.list5, _.dataOverviewQuery).then((res) => {
        _.bindList = res.data.data || {};

        const first = res.data.data.pieChartData || []; // 总量占比
        const second = res.data.data.pieChartDataIncrement || []; // 增量占比
        const list = res.data.data.table || {}; // 表格数据

        _.bindTotalList = [
          {
            name: "用户数",
            bindA: list[1].bindUserTotal,
            bindB: list[2].bindUserTotal,
            bindC: list[3].bindUserTotal,
            bindD: list[4].bindUserTotal,
            bindE: list[5].bindUserTotal,
          },
          {
            name: "占比",
            bindA: list[1].percentage + "%",
            bindB: list[2].percentage + "%",
            bindC: list[3].percentage + "%",
            bindD: list[4].percentage + "%",
            bindE: list[5].percentage + "%",
          },
        ];
        _.bindIncrementList = [
          {
            name: "用户数",
            bindA: list[1].bindUserIncrement,
            bindB: list[2].bindUserIncrement,
            bindC: list[3].bindUserIncrement,
            bindD: list[4].bindUserIncrement,
            bindE: list[5].bindUserIncrement,
          },
          {
            name: "占比",
            bindA: list[1].percentageIncrement + "%",
            bindB: list[2].percentageIncrement + "%",
            bindC: list[3].percentageIncrement + "%",
            bindD: list[4].percentageIncrement + "%",
            bindE: list[5].percentageIncrement + "%",
          },
          {
            name: "上周期环比",
            bindA: list[1].chainRatio + "%",
            bindB: list[2].chainRatio + "%",
            bindC: list[3].chainRatio + "%",
            bindD: list[4].chainRatio + "%",
            bindE: list[5].chainRatio + "%",
          },
        ];

        const firstList = [
          { name: "支付宝公域扫码绑定(总数)", value: first[0].value },
          { name: "APP/小程序绑定用户数(总数)", value: first[1].value },
          {
            name: "已绑定桩数据推送至支付宝用户数(总数)",
            value: first[2].value,
          },
          { name: "APP绑定推送成功(总数)", value: first[3].value },
          { name: "一键登录绑定推送成功(总数)", value: first[4].value },
        ];
        const secondList = [
          { name: "支付宝公域扫码绑定(增量)", value: second[0].value },
          { name: "APP/小程序绑定用户数(增量)", value: second[1].value },
          {
            name: "已绑定桩数据推送至支付宝用户数(增量)",
            value: second[2].value,
          },
          { name: "APP绑定推送成功(增量)", value: second[3].value },
          { name: "一键登录绑定推送成功(增量)", value: second[4].value },
        ];
        // 基于准备好的dom，初始化echarts实例
        let firstChart = this.$echarts.init(
          document.getElementById("bind-first")
        );
        let secondChart = this.$echarts.init(
          document.getElementById("bind-second")
        );
        firstChart.setOption({
          title: {
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
            show: false,
          },
          series: [
            {
              type: "pie",
              radius: "50%",
              data: firstList || [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        });
        secondChart.setOption({
          title: {
            left: "center",
          },
          tooltip: {
            trigger: "item",
          },
          legend: {
            orient: "vertical",
            left: "left",
            show: false,
          },
          series: [
            {
              type: "pie",
              radius: "50%",
              data: secondList || [],
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        });

        setTimeout(() => {
          window.addEventListener("resize", function () {
            firstChart.resize();
            secondChart.resize();
          });
        }, 500);
      });
    },
    // 重置
    resetQuery() {
      let _ = this;
      _.queryInfo = {
        dateType: 0,
        dateStr: "",
        pageType: "A_TYPE",
      };
      _.init();
    },

    // 选择时间 周
    handleSelectTime(val) {
      console.log(val);
      let _ = this;
      if (val) {
        const date = new Date(val);
        const year = date.getFullYear();
        const weekOfYear = _.getWeekOfYear(date);
        _.dataOverviewQuery.dateStr = year + "-" + Number(weekOfYear + 1);
        this.getDataOverview() // 数据总览
        this.getUserParticipateActivity() // 用户参与活动关键流程趋势图
        this.getListData() // 渠道统计
        this.getUserBindPile() // 用户已绑桩数据统计
      }
    },
    getWeekOfYear(date) {
      const startOfYear = new Date(date.getFullYear(), 0, 1);
      const pastDaysOfYear = (date - startOfYear) / 86400000 + 1; // 86400000 = 24 * 60 * 60 * 1000
      return Math.ceil(pastDaysOfYear / 7);
    },

    // 切换 活动页 类型
    handleSelectPageType(row) {
      let _ = this;
      _.queryInfo.pageType = row.value;
      _.dataOverviewQuery.pageType = row.value;
      _.getListData();
    },
    cascaderChange(val) {
      console.log(val)
      if (val.length > 0) {
        this.channelCodeList = val.map(item => item[2])
      } else {
        this.channelCodeList = []
      }
      this.getUserParticipateActivity()
      console.log(this.channelCodeList)

    },
    convertTreeToPaths(treeData) {
      const result = [];

      // 递归处理节点
      function traverse(node, currentPath = []) {
        // 将当前节点的值加入路径
        const newPath = [...currentPath, node.value];

        // 如果有子节点，继续递归处理
        if (node.children && node.children.length > 0) {
          node.children.forEach(child => {
            traverse(child, newPath);
          });
        } else {
          // 没有子节点，说明是叶子节点，将完整路径加入结果
          result.push(newPath);
        }
      }

      // 处理根节点数组
      treeData.forEach(rootNode => {
        traverse(rootNode);
      });

      return result;
    },
  },
};
</script>

<style scoped lang="less">
.content-item1 {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: flex-start;

  .item3-left {
    width: calc(50% - 10px);
    height: 400px;
    margin-right: 10px;
  }

  .item3-right {
    width: calc(50% - 10px);
    height: 400px;
    margin-left: 10px;
  }

  .item2-left {
    width: calc(30% - 10px);
    height: 400px;
    margin-right: 10px;
  }

  .item2-right {
    width: calc(70% - 10px);
    height: 400px;
    margin-left: 10px;
  }

  .item1-left {
    width: calc(50% - 10px);
    margin-right: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 600px;

    .item8-title {
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      font-weight: bold;
      padding-bottom: 10px;
      box-sizing: border-box;
    }

    >div {
      height: 100%;
      width: 45%;

      &:nth-child(1) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        >div {
          height: 100px;
        }
      }

      &:nth-child(2) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        >div {
          height: 100px;
        }
      }
    }

    .left-info {
      width: calc(100% / 3);
      display: flex;
      flex-direction: column;
      align-items: center;

      .info-box {
        width: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;

        div:first-child {
          font-size: 24px;
          font-weight: bold;
        }
      }
    }
  }

  .item1-right {
    width: calc(50% - 10px);
    margin-left: 10px;
    display: flex;
    height: 600px;
    flex-direction: column;
    // align-items: center;
    // justify-content: center;
    font-size: 16px;
    line-height: 56px;

    .item8-title {
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      font-weight: bold;
      padding-bottom: 10px;
      box-sizing: border-box;
    }

    .right-info {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;

      div:last-child {
        font-weight: bold;
        font-size: 24px;
      }
    }
  }
}

.item-title-select {
  display: flex;
  align-items: center;
  width: 320px;
  height: 32px;
  line-height: 32px;
  border: 1px solid #ddd;
  border-radius: 32px;
  margin-bottom: 16px;

  .active {
    color: #4182eb;
    font-weight: bold;
  }

  .select-item {
    width: 120px;
    text-align: center;
    cursor: pointer;
  }

  .select-item:first-child {
    border-right: 1px solid #ddd;
  }

  .select-item:last-child {
    border-left: 1px solid #ddd;
  }
}

.content-item2 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .item2-title {
    width: 100%;
    font-size: 16px;
    line-height: 48px;
    font-weight: bold;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .item2-info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .info-box {
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      div:nth-child(1) {
        font-size: 14px;
        margin-bottom: 8px;
      }

      div:nth-child(2) {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      div:nth-child(3) {
        font-size: 12px;
        color: #888;
        margin-bottom: 8px;
      }

      div:nth-child(4) {
        font-size: 14px;
        color: #4182eb;
      }
    }

    .info-symbol {
      font-size: 40px;
      font-weight: bold;
    }
  }
}

.content-item3 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .item3-title {
    width: 100%;
    font-size: 16px;
    line-height: 48px;
    font-weight: bold;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .item3-info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .info-box {
      width: 100%;
      display: flex;
      align-items: center;
      flex-direction: column;

      div:nth-child(1) {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 8px;
      }

      div:nth-child(2) {
        font-size: 14px;
        margin-bottom: 8px;
      }

      div:nth-child(3) {
        font-size: 12px;
        color: #888;
      }
    }

    .info-symbol {
      font-size: 40px;
      font-weight: bold;
    }
  }
}

.content-item4 {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  .item4-title {
    width: 100%;
    font-size: 16px;
    line-height: 48px;
    font-weight: bold;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .item4-info {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;

    .info-box {
      width: calc(100% / 3);
      display: flex;
      align-items: center;
      justify-content: space-around;
      border-right: 1px solid #ddd;
      padding: 0 16px;
      box-sizing: border-box;

      .info-left {
        display: flex;
        align-items: center;
        flex-direction: column;

        div:nth-child(2) {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 8px;
        }
      }

      .info-right {
        display: flex;
        align-items: center;
        flex-direction: column;

        .right-top {
          margin-bottom: 12px;
        }

        .right-top,
        .right-bottom {
          display: flex;
          align-items: center;

          div:first-child {
            margin-right: 10px;
          }

          div:last-child {
            font-size: 16px;
            font-weight: bold;
          }
        }
      }
    }

    .info-box:last-child {
      border: none;
    }
  }
}

.content-item5 {
  width: 100%;
  display: flex;
  align-items: stretch;

  .item5-chart {
    width: 40%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .item5-title {
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      font-weight: bold;
    }

    .registration-trends {
      width: 100%;
      height: 257px;
    }
  }

  .item5-table {
    width: 60%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .item5-title {
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      font-weight: bold;
    }
  }
}

.content-item6 {
  width: 100%;
  display: flex;
  align-items: stretch;

  .item6-left {
    width: 48%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .left-top {
      width: 100%;
      display: flex;
      flex-direction: column;

      .item6-title {
        width: 100%;
        font-size: 14px;
        line-height: 48px;
        font-weight: bold;
      }

      .item6-info {
        display: flex;
        align-items: center;
        height: 100px;

        .info-list {
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: stretch;

          .list-first {
            font-size: 24px;
            font-weight: bold;
          }

          .list-second {
            font-size: 14px;
          }

          .list-third {
            font-size: 14px;
            margin-bottom: 8px;
          }

          .list-fourth {
            font-size: 14px;
          }
        }
      }
    }

    .left-chart-box {
      width: 100%;
      display: flex;

      .chart-box-info {
        width: 100%;
        display: flex;
        flex-direction: column;

        .item6-title {
          width: 100%;
          font-size: 14px;
          line-height: 48px;
          font-weight: bold;
        }

        .chart-second,
        .chart-first {
          width: 100%;
          height: 248px;
        }
      }
    }
  }

  .item6-right {
    width: 52%;
  }
}

.content-item7 {
  width: 100%;
  display: flex;
  flex-direction: column;

  .item7-title {
    width: 100%;
    font-size: 16px;
    line-height: 48px;
    font-weight: bold;
    padding-bottom: 10px;
    box-sizing: border-box;
  }

  .item7-info {
    width: 100%;
    display: flex;
    align-items: stretch;

    .item7-left {
      width: 30%;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;

      .left-list {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        div:first-child {
          font-size: 24px;
          font-weight: bold;
          margin-bottom: 18px;
        }

        div:last-child {
          font-size: 16px;
        }
      }
    }

    .item7-right {
      width: 70%;
    }
  }
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}

.border-line {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
}

.content-item8 {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: space-between;

  .item8-info {
    width: calc(20% - 16px);
    display: flex;
    flex-direction: column;

    .item8-title {
      width: 100%;
      font-size: 16px;
      line-height: 48px;
      font-weight: bold;
      padding-bottom: 10px;
      box-sizing: border-box;
    }

    .item8-value {
      font-size: 24px;
      font-weight: bold;
      margin-bottom: 8px;
    }
  }
}

.shuaxin {
  background: url("https://img.cdn.wxzhida.cn/zd-ali-app/shuaxining.png");
  width: 30px;
  height: 30px;
  background-size: 100% 100%;
  cursor: pointer;
}

.shuaxuan-date {
  display: flex;
  align-items: center;
  color: #515a6e;
  cursor: pointer;

  >div {
    margin-right: 35px;
  }
}

.item4-title {
  width: 100%;
  font-size: 16px;
  line-height: 48px;
  font-weight: bold;
  padding-bottom: 10px;
  box-sizing: border-box;
}

.font-deep {
  font-weight: 600;
}

.font-size18 {
  font-size: 18px;
}

.font-size16 {
  font-size: 16px;
}

.font-size14 {
  font-size: 14px;
}
</style>
